import { emailMultiple as isValidEmail } from '@edicom/common/validator/emailMultiple';
import { getBooleanValue } from '../../../shared/api/session/getBooleanValue.js';
import { showFormAlert } from '../view/showFormAlert.js';

/* EXAMPLE stepData
  {
      "email": "user@email.com",
  }
*/
export default {
  events: {
    visible: (eWizard, stepData, params) => {
      // setExtraInformation
      if (params.extraInformation) {
        const eAlert = eWizard.querySelector('#alertEmail');
        if (eAlert) {
          eAlert.lastElementChild.innerHTML = edicom.locale.translate(params.extraInformation);
        }
      }

      // email: new or update/confirm
      if (stepData.email) {
        const eField = eWizard.querySelector('#email');
        const eFieldConfirm = eWizard.querySelector('#emailConfirm');
        if (eField && eFieldConfirm) {
          eField.value = stepData.email;
          eFieldConfirm.value = stepData.email;
        }
      }

      // emailRequired: defualt true
      if (getBooleanValue(params.optional)) {
        eWizard.querySelector('#email')?.removeAttribute('required');
        eWizard.querySelector('#emailConfirm')?.removeAttribute('required');
      }
    },
    step: (eWizard, stepData, resolve, reject) => {
      const email = eWizard.querySelector('#email')?.value;
      const emailConfirm = eWizard.querySelector('#emailConfirm')?.value;
      const emailRequired = eWizard.querySelector('#email')?.hasAttribute('required');

      if (emailRequired && (!email || !emailConfirm)) {
        showFormAlert();
      } else if (!isValidEmail(email)) {
        showFormAlert('login.error_email_validation');
      } else if (email !== emailConfirm) {
        showFormAlert('login.error_emailDistinct');
      } else {
        stepData.email = email || '';
        resolve(stepData);
        return; // OK
      }

      reject(); // KO
    },
  },
  template: `
  <template label="${edicom.locale.translate('enrollment.bmemail.title')}">
    <ewc-alert id="alertEmail" type="flat" label="${edicom.locale.translate('enrollment.bmemail.title')}">
      <div style="white-space:normal;">${edicom.locale.translate('enrollment.bmemail.intro')}</div>
    </ewc-alert>
    <ewc-form-layout>
      <ewc-string id="email" label="${edicom.locale.translate('enrollment.bmemail.label.email')}" maxlength="255" type="email" multiple required cols="4"></ewc-string>
      <ewc-string id="emailConfirm" label="${edicom.locale.translate(
        'enrollment.bmemail.label.emailConfirm'
      )}" maxlength="255" type="email" multiple required cols="4"></ewc-string>
    </ewc-form-layout>
  </template>`,
};
